import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tab']

  connect() {
    // Click on the deep-linked tab
    this.activate_tab_from_fragment();
  }

  activate_tab_from_fragment() {
    const fragment = window.location.hash;
    const all_tabs = this.tabTargets;

    const target_tab = all_tabs.find(tab => tab.getAttribute('href') === fragment);

    if (fragment && target_tab) {
      target_tab.parentElement.click();
    } else if (all_tabs[0]) {
      all_tabs[0].parentElement.click();
    }
  }
}
